import PropTypes from 'prop-types';
import { all, equals } from 'ramda';
import { withTheme } from 'styled-components';
import { renderWhenTrue } from '../../utils/rendering';
import { matchBreakpoint } from '../../../theme/getters';
import { Breakpoints } from '../../../theme/media';

export const HiddenOnPlatformComponent = ({ children, theme, below, above, ...props }) => {
  const matchesExplicitProp = !!props[theme.activeBreakpoint];
  const matchesAboveProp = above && matchBreakpoint(above, true)({ theme });
  const matchesBelowProp = below && !matchBreakpoint(below, false)({ theme });

  const shouldRender = all(equals(false), [matchesExplicitProp, !!matchesAboveProp, !!matchesBelowProp]);

  return renderWhenTrue(() => children)(shouldRender);
};

export default withTheme(HiddenOnPlatformComponent);

HiddenOnPlatformComponent.propTypes = {
  children: PropTypes.any,
  theme: PropTypes.object,
  below: PropTypes.oneOf(Object.values(Breakpoints)),
  above: PropTypes.oneOf(Object.values(Breakpoints)),
};
